import 'core-js/modules/es.symbol';
import 'core-js/modules/es.symbol.description';
import 'core-js/modules/es.symbol.to-primitive';
import 'core-js/modules/es.array.concat';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.date.to-primitive';
import 'core-js/modules/es.number.constructor';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.split';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';
import { assertType, assert } from 'yaassertion';
import { SmartCache } from '@paypalcorp/worldready-smart-cache';
import '@paypalcorp/globalize/dist/globalize/number';
import '@paypalcorp/globalize/dist/globalize/date';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded = ["style"];
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DATE_STYLES = {
  DATE_SHORT: "date-short",
  BANK_CARD_EXPIRY: "bank-card-expiry",
  TIMEZONE_SHORT: "timezone-short",
  TIMEZONE_MEDIUM: "timezone-medium",
  TIMEZONE_LONG: "timezone-long"
};
var BANK_CARD_EXPIRY_FORMAT = "MM/YY";
var TIMEZONE_FORMATS = {
  TIMEZONE_LONG_FORMAT: "(OOOO) vvvv (VVV)",
  TIMEZONE_MEDIUM_FORMAT: "(OOOO) vvvv",
  TIMEZONE_SHORT_FORMAT: "(OOOO) v"
};
var ERROR_CODES = {
  E_MISSING_CLDR: "E_MISSING_CLDR",
  E_MISSING_IANA_TZ: "E_MISSING_IANA_TZ"
};

/**
 * Modified globalizeDateOptions based on date styles and formats
 * @param {optionsWithDefaults, globalizeDateOptions, aux}
 * @return {globalizeDateOptions}
 */
function getGlobalizeDateOptions(optionsWithDefaults, globalizeDateOptions, aux) {
  switch (optionsWithDefaults.style) {
    case DATE_STYLES.BANK_CARD_EXPIRY:
      globalizeDateOptions["raw"] = BANK_CARD_EXPIRY_FORMAT;
      globalizeDateOptions.timeZone = optionsWithDefaults.timeZone;
      return globalizeDateOptions;
    case DATE_STYLES.TIMEZONE_LONG:
      globalizeDateOptions["raw"] = TIMEZONE_FORMATS.TIMEZONE_LONG_FORMAT;
      globalizeDateOptions.timeZone = optionsWithDefaults.timeZone;
      return globalizeDateOptions;
    case DATE_STYLES.TIMEZONE_MEDIUM:
      globalizeDateOptions["raw"] = TIMEZONE_FORMATS.TIMEZONE_MEDIUM_FORMAT;
      globalizeDateOptions.timeZone = optionsWithDefaults.timeZone;
      return globalizeDateOptions;
    case DATE_STYLES.TIMEZONE_SHORT:
      globalizeDateOptions["raw"] = TIMEZONE_FORMATS.TIMEZONE_SHORT_FORMAT;
      globalizeDateOptions.timeZone = optionsWithDefaults.timeZone;
      return globalizeDateOptions;
    default:
      if (optionsWithDefaults.style.includes("-")) {
        aux = optionsWithDefaults.style.split("-");
        globalizeDateOptions[aux[0]] = aux[1];
      } else {
        globalizeDateOptions.skeleton = optionsWithDefaults.style;
      }
      globalizeDateOptions.timeZone = optionsWithDefaults.timeZone;
      return globalizeDateOptions;
  }
}
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function globalizeToWorldReadyError(error) {
  if (error.code === "E_MISSING_CLDR") {
    return getMissingMetadataError(error.stack);
  }
  return new Error(["Oops, internal error", error.message, error.stack].join("\n"));
}
function getWorldReadyDateError(error, options) {
  if (options === void 0) {
    options = {};
  }
  var WORLDREADY_DATE_ERROR_CODES = {
    E_INVALID_OPTIONS: "E_INVALID_OPTIONS",
    E_MISSING_IANA_TZ: "E_MISSING_IANA_TZ"
  };
  if (error.code === WORLDREADY_DATE_ERROR_CODES.E_INVALID_OPTIONS) {
    throw new RangeError("Invalid `options.style`: `" + JSON.stringify(error.value) + "`.");
  } else if (error.code === WORLDREADY_DATE_ERROR_CODES.E_MISSING_IANA_TZ) {
    throw new Error("Missing required timezone metadata. Make sure that you are exporting metadata for \"" + options.timeZone + "\" using WorldReady.export API.");
  }
  throw globalizeToWorldReadyError(error);
}

/**
 * DateTimeFormat(worldReady, options)
 */
var DateTimeFormat = /*#__PURE__*/function () {
  function DateTimeFormat(worldReady, options) {
    if (options === void 0) {
      options = {};
    }
    // Error checking
    if (process.env.NODE_ENV !== "production") {
      assert(isWorldReadyInstance(worldReady), "WorldReady object missing.");
      assertType(options, "options", ["plain object"]);
      assertType(options.style, "options.style", ["string", "undefined"]);
      assertType(options.timeZone, "options.timeZone", ["string"]);
    }
    this.dateOptions = globalizeDateOptions(options);
    this.locale = worldReady.locale;
    this.globalize = worldReady.globalize;

    // Check if required metadata for locale & timezone is present or not
    var cldr = worldReady.globalize.cldr;
    var datesMetadata = cldr.main("dates");
    if (!datesMetadata) {
      var err = new Error();
      err.code = ERROR_CODES.E_MISSING_CLDR;
      throw getWorldReadyDateError(err);
    }
    var timezones = options.timeZone.split("/");
    var timezoneMetadata = cldr.get(["globalize-iana/zoneData"].concat(timezones));
    if (!timezoneMetadata) {
      var _err = new Error();
      _err.code = ERROR_CODES.E_MISSING_IANA_TZ;
      throw getWorldReadyDateError(_err, {
        timeZone: options.timeZone
      });
    }
  }
  var _proto = DateTimeFormat.prototype;
  _proto.format = function format(date) {
    if (!isValidDate(date)) {
      if (process.env.NODE_ENV !== "production") {
        throw new TypeError("Invalid Date was provided with value: " + date);
      }
      return NaN;
    }
    try {
      this.dateFormatter = getDateFormatter({
        locale: this.locale,
        options: this.dateOptions,
        globalize: this.globalize
      });
      return this.dateFormatter(date);
    } catch (error) {
      throw getWorldReadyDateError(error);
    }
  };
  _proto.formatToParts = function formatToParts(date) {
    if (!isValidDate(date)) {
      if (process.env.NODE_ENV !== "production") {
        throw new TypeError("Invalid Date was provided with value: " + date);
      }
      return NaN;
    }
    try {
      this.dateToPartsFormatter = getDateToPartsFormatter({
        locale: this.locale,
        options: this.dateOptions,
        globalize: this.globalize
      });
      return this.dateToPartsFormatter(date);
    } catch (error) {
      throw getWorldReadyDateError(error);
    }
  };
  _proto.parse = function parse(localizedDate) {
    if (process.env.NODE_ENV !== "production") {
      assertType(localizedDate, "localizedDate", ["string"]);
    }
    try {
      this.dateParser = getDateParser({
        locale: this.locale,
        options: this.dateOptions,
        globalize: this.globalize
      });
      return this.dateParser(localizedDate);
    } catch (error) {
      throw getWorldReadyDateError(error);
    }
  };
  return DateTimeFormat;
}();
_defineProperty(DateTimeFormat, "smartCache", new SmartCache());
function getDateFormatter(data) {
  if (data === void 0) {
    data = {};
  }
  var _data = data,
    locale = _data.locale,
    options = _data.options,
    globalize = _data.globalize;
  var key = "dateFormatter" + JSON.stringify({
    locale: locale,
    options: options
  });
  if (!DateTimeFormat.smartCache.has(key)) {
    DateTimeFormat.smartCache.set(key, globalize.dateFormatter(options));
  }
  return DateTimeFormat.smartCache.get(key);
}
function getDateToPartsFormatter(data) {
  if (data === void 0) {
    data = {};
  }
  var _data2 = data,
    locale = _data2.locale,
    options = _data2.options,
    globalize = _data2.globalize;
  var key = "dateToPartsFormatter" + JSON.stringify({
    locale: locale,
    options: options
  });
  if (!DateTimeFormat.smartCache.has(key)) {
    DateTimeFormat.smartCache.set(key, globalize.dateToPartsFormatter(options));
  }
  return DateTimeFormat.smartCache.get(key);
}
function getDateParser(data) {
  if (data === void 0) {
    data = {};
  }
  var _data3 = data,
    locale = _data3.locale,
    options = _data3.options,
    globalize = _data3.globalize;
  var key = "dateParser" + JSON.stringify({
    locale: locale,
    options: options
  });
  if (!DateTimeFormat.smartCache.has(key)) {
    DateTimeFormat.smartCache.set(key, globalize.dateParser(options));
  }
  return DateTimeFormat.smartCache.get(key);
}
function globalizeDateOptions(options) {
  var aux;
  var globalizeDateOptions = {};

  // Set Defaults
  var _options$style = options.style,
    style = _options$style === void 0 ? DATE_STYLES.DATE_SHORT : _options$style,
    otherProps = _objectWithoutPropertiesLoose(options, _excluded);
  var optionsWithDefaults = Object.assign({
    style: style
  }, otherProps);
  globalizeDateOptions = getGlobalizeDateOptions(optionsWithDefaults, globalizeDateOptions, aux);
  return globalizeDateOptions;
}
/**
 * Validates if date is valid Date object.
 * Due that one of the values returned by new Date() function could be `Invalid Date` which is actually a valid Date object
 * We are also validating date parameter is a valid number.
 * @param {Date} date
 * @returns {Boolean}
 */

function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}

export { DateTimeFormat };
